import { useMutation, useQueryClient } from "@tanstack/react-query"
import { apiFetch } from "../../../framework/api"
import { useAuthToken } from "../../../hooks/useAuthToken"

export function useDeletePreparedPush() {
  const token = useAuthToken()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (uid: string) => {
      await apiFetch(`/admin/prepared-pushes/${uid}`, {
        token,
        method: "DELETE",
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["preparedPushes"] })
    },
  })
}

